import React from "react";
import { Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { TextDecrypt } from "../content/TextDecrypt";
import Resume from "../../settings/resume.json";
import "./Skills.css";

const useStyles = makeStyles((theme) => ({
  main: {
    maxWidth: '100vw',
    marginTop: '3em',
    marginBottom: "3em",
  },
}));

// Technology icons mapping using devicon and font-awesome classes
const techIcons = {
  // Programming Languages
  "JavaScript": { icon: "fab fa-js-square", color: "#F7DF1E" },
  "Python": { icon: "fab fa-python", color: "#3776AB" },
  "PHP": { icon: "fab fa-php", color: "#777BB4" },
  "SQL": { icon: "fas fa-database", color: "#4479A1" },
  
  // Backend
  "Node.js": { icon: "fab fa-node-js", color: "#339933" },
  "FastAPI": { icon: "fas fa-bolt", color: "#009688" },
  "Laravel": { icon: "fab fa-laravel", color: "#FF2D20" },
  "MongoDB": { icon: "fas fa-leaf", color: "#47A248" },
  "Supabase": { icon: "fas fa-database", color: "#3ECF8E" },
  "Firebase": { icon: "fas fa-fire", color: "#FFCA28" },
  
  // Frontend
  "React": { icon: "fab fa-react", color: "#61DAFB" },
  "HTML": { icon: "fab fa-html5", color: "#E34F26" },
  "CSS": { icon: "fab fa-css3-alt", color: "#1572B6" },
  "Tailwind CSS": { icon: "fas fa-wind", color: "#06B6D4" },
  "Bootstrap": { icon: "fab fa-bootstrap", color: "#7952B3" },
  
  // ML & AI
  "PyTorch": { icon: "fas fa-fire-alt", color: "#EE4C2C" },
  "TensorFlow": { icon: "fas fa-brain", color: "#FF6F00" },
  "Keras": { icon: "fas fa-layer-group", color: "#D00000" },
  "NumPy": { icon: "fas fa-square-root-alt", color: "#013243" },
  "Scikit-learn": { icon: "fas fa-chart-line", color: "#F7931E" },
  
  // Cloud & DevOps
  "Google Cloud": { icon: "fab fa-google", color: "#4285F4" },
  "AWS": { icon: "fab fa-aws", color: "#FF9900" },
  "Docker": { icon: "fab fa-docker", color: "#2496ED" },
  "Git": { icon: "fab fa-git-alt", color: "#F05032" },
  "Hugging Face": { icon: "fas fa-smile", color: "#FFD21E" },
  
  // IoT
  "IoT Development": { icon: "fas fa-microchip", color: "#00979D" },
  "Embedded Systems": { icon: "fas fa-memory", color: "#00ADD8" },
  "Sensor Integration": { icon: "fas fa-wifi", color: "#0DB7ED" },
};

// Category icons
const categoryIcons = {
  "Programming Languages": "fas fa-code",
  "Backend Development": "fas fa-server",
  "Frontend Development": "fas fa-desktop",
  "Machine Learning & AI": "fas fa-brain",
  "Cloud & DevOps": "fas fa-cloud",
  "Internet of Things (IoT)": "fas fa-microchip",
};

export const Skills = () => {
  const classes = useStyles();

  return (
    <section id="skills">
      <Container component="main" className={classes.main} maxWidth="lg">
        <div className="skills-section">
          <h2 className="skills-title">
            <TextDecrypt text="Skills & Technologies" />
          </h2>

          <div className="skills-grid">
            {Resume.skills.map((skillCategory, index) => (
              <div key={index} className="skill-category">
                <h3 className="skill-category-title">
                  <i className={`${categoryIcons[skillCategory.name]} skill-category-icon`}></i>
                  {skillCategory.name}
                </h3>
                <div className="skills-list">
                  {skillCategory.keywords.map((skill, idx) => (
                    <div key={idx} className="skill-item">
                      {techIcons[skill] && (
                        <i 
                          className={`${techIcons[skill].icon} skill-icon`}
                          style={{ color: techIcons[skill].color }}
                        ></i>
                      )}
                      <span>{skill}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
};
